// node env 등 환경설정 내용을 구조화 해 내보낸다.

const Config = {
  adApiBaseUrl: process.env.REACT_APP_AD_API_BASE_URL,
  apiBaseUrl: `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}`,
  fileServerBaseUrl: `${process.env.REACT_APP_FILESERVER_PROTOCOL}://${process.env.REACT_APP_FILESERVER_HOST}:${process.env.REACT_APP_FILESERVER_PORT}`,
  chatServerApiBaseUrl: `${process.env.REACT_APP_CHATSERVER_API_PROTOCOL}://${process.env.REACT_APP_CHATSERVER_HOST}:${process.env.REACT_APP_CHATSERVER_API_PORT}`,
  chatServerSocketioUrl: `${process.env.REACT_APP_CHATSERVER_SOCKETIO_PROTOCOL}://${process.env.REACT_APP_CHATSERVER_SOCKETIO_HOST}:${process.env.REACT_APP_CHATSERVER_SOCKETIO_PORT}`,
  chatServerSocketioPath: `${process.env.REACT_APP_CHATSERVER_SOCKETIO_PATH}`,

  sseTokenRefreshIntervalInSec: parseInt(
    process.env.REACT_APP_SSE_TOKEN_REFRESH_INTERVAL_IN_SEC as string,
  ),

  contentImagePathPrefix: '/contentImage',
  smallContentImagePathPrefix: '/contentImage/small',
  contentVideoPathPrefix: '/contentVideo',
  contentVideoThumbnailPathPrefix: '/contentVideo/thumbnail',
  contentAttachmentPathPrefix: '/contentAttachment',
  contentAudioPathPrefix: '/contentAudio',

  kkmomModudaUrl: `${process.env.REACT_APP_KKMOM_MODUDA_URL}`,
  anotherClassModudaUrl: `${process.env.REACT_APP_AC_MODUDA_URL}`,
  guestLinkUrlPrefix: `${process.env.REACT_APP_GUEST_LINK_URL_PREFIX}`,
  kakaoOpenExternalScheme: `${process.env.REACT_APP_KAKAO_OPEN_EXTERNAL_SCHEME}`,
};

export default Config;
